// ====== Input Slice Selectors ======
const frontendBootSelector = (state) => state.input.frontendBootData;
const leadDataSelector = (state) => state.input.leadData;
const filtersSelector = (state) => state.input.filters;
const currencySelector = (state) => state.input.leadData.currency;
const activeStepSelector = (state) => state.input.activeStep;
const tataSelector = (state) => state.input.blockTata;
const disableMembersSelector = (state) => state.input.disableMembers;


// ====== Quote Slice Selectors ======
const quoteSelector = (state) => state.quote;
const knowMoreSelector = (state) => state.quote.knowMoreData;
const knowMoreDataSelector = (state) => state.quote.knowMoreData.data;
const knowMoreICDataSelector = (state) => state.quote.knowMoreData.ic_data;
const compareQuoteSelector = (state) => state.quote.compareQuote;
const shortListedQuotesSelector = (state) => state.quote.shortListedQuotes;
const quotesToShareSelector = (state) => state.quote.quotesToShare;

// ====== Proposal Slice Selectors ======
const proposalSelector = (state) => state.proposal;

export {
  activeStepSelector,
  compareQuoteSelector,
  currencySelector,
  filtersSelector,
  frontendBootSelector,
  knowMoreDataSelector,
  knowMoreICDataSelector,
  knowMoreSelector,
  leadDataSelector,
  proposalSelector,
  quoteSelector,
  quotesToShareSelector,
  shortListedQuotesSelector,
  disableMembersSelector,
  tataSelector
};
